// @ts-check
import {Text, Toggle} from '@/components-v2/atoms'
import {TextInput} from '@/components-v2/molecules'
import {MaxDiscountModal} from '@/components/organisms'
import {usePromotion} from '@/context/Promotion/PromotionContext'
import {selectCountryCode} from '@/store/slices/countryCodeSlice'
import {COUNTRY_CODES} from '@/utils/constants/countryConstants'
import {PromotionType} from '@/utils/constants/promotionConstants'
import {useSelector} from 'react-redux'
import {useLocation} from 'react-router-dom'
import {PromotionConditionSection} from './PromotionConditionSection'
import {PromotionSegmentSection} from './PromotionSegmentSection'

export const PromotionSetupStep = () => {
  const {
    promotion: finalResult,
    onResultChange,
    handleUpdatePromotionConfig,
    maxDiscountModalVisible,
    setMaxDiscountModalVisible,
    promotionConfig,
  } = usePromotion()
  const location = useLocation()
  const {isDuplicating} = location.state || {}
  const nonEditable = finalResult?.status?.toUpperCase() === 'PUBLISHED' && !isDuplicating
  const countryCode = useSelector(selectCountryCode)
  const handleSaveMaxDiscountConfig = async newDiscount => {
    try {
      await handleUpdatePromotionConfig({maxDiscountPercentage: newDiscount})
    } catch (error) {
      console.error('Error updating max discount config:', error)
      throw error
    }
  }
  const isToggleBtnVisible =
    countryCode === COUNTRY_CODES.TR &&
    finalResult?.promotionType !== PromotionType.STORE_DISCOUNT &&
    finalResult?.promotionType !== PromotionType.WELCOME_DISCOUNT

  return (
    <div className="flex flex-col gap-6 rounded-lg p-6">
      <div className="flex flex-col gap-6 rounded-lg bg-[var(--color-background-layer-01)] p-6">
        <Text headingLevel={5} variant="bold">
          Name Promotion
        </Text>
        <div className="w-[300px]">
          <TextInput
            label="Name*"
            onUpdate={value => onResultChange({name: value})}
            value={finalResult?.name || ''}
            placeholderText="Promotion Name"
            disabled={nonEditable}
          />
        </div>
        {isToggleBtnVisible && (
          <Toggle
            onUpdate={value => onResultChange({onlineDiscountEligible: value})}
            checked={!!finalResult?.onlineDiscountEligible}
            size="small"
            label="Online Discount"
          />
        )}
      </div>

      <PromotionConditionSection />
      <PromotionSegmentSection />

      <MaxDiscountModal
        maxDiscountValue={promotionConfig?.maxDiscountPercentage}
        showModal={maxDiscountModalVisible}
        onCloseModal={() => setMaxDiscountModalVisible(false)}
        onSaveDiscount={handleSaveMaxDiscountConfig}
      />
    </div>
  )
}
